import styles from "./styles.module.scss";

export const getMaterialByStep = (step: number) => {
  switch (step) {
    case 1:
      return <ConnectAmazonAccountsMaterial />;
    case 2:
      return <AddCogsMaterial />;
    case 4:
      return <SetupMarketShareMaterial />;
    default:
      return null;
  }
};

export const ConnectAmazonAccountsMaterial = () => {
  return (
    <div className={styles.material}>
      <p>
        Unlock the Full Power of Data-Driven Insights for Your Amazon Business!
        Connecting your Amazon Seller and Amazon Ads accounts allows our
        platform to securely access and analyze your business data, including:
      </p>
      <ul>
        <li>Sales performance (orders, revenue, units sold)</li>
        <li>Advertising metrics (clicks, impressions, ACoS, ROAS)</li>
        <li>Inventory levels and fulfillment data</li>
        <li>Customer behavior and search trends</li>
        <li>Competitor benchmarking and market insights</li>
      </ul>
      <p>
        Once connected, our advanced AI and machine learning models process this
        data to provide actionable recommendations tailored to your business.
      </p>
    </div>
  );
};

export const AddCogsMaterial = () => {
  return (
    <div className={styles.material}>
      <p>
        Our platform needs to know the cost of each product (COGS) to calculate
        profitability metrics (ROI, contribution profit) that are blurred in the
        interface currently. Without COGS, the system cannot determine:
      </p>
      <ul>
        <li>How much money is left after covering the cost of the product.</li>
        <li>Whether the product is profitable or not</li>
        <li>The ROI for each ASIN.</li>
      </ul>
      <p>
        COGS represents the direct costs associated with producing or purchasing
        a product. Once COGS is entered, you will be able to see in the products
        table:
      </p>
      <ul>
        <li>
          ROI per ASIN: Helps you identify which products are most profitable.
        </li>
        <li>
          Contribution Profit per ASIN: Helps you understand how much each
          product contributes to overall profitability.
        </li>
      </ul>
    </div>
  );
};

export const SetupMarketShareMaterial = () => {
  return (
    <div className={styles.material}>
      <p>
        The "WHAT IF" mode in Canvas empowers you to explore how different
        Market Share Goals impact your business. Use this tool to set realistic
        targets, plan strategically, and achieve sustainable growth—all backed
        by data-driven insights.
      </p>
      <p>HOW IT WORKS?</p>
      <ol type="1">
        <li>Choose a Goal That Fits Your Strategy</li>
        <ol type="a">
          <li>
            Recommended Goal : Our platform analyzes your current performance,
            market trends, and industry benchmarks to suggest a realistic
            target. This is perfect if you're unsure where to start.
          </li>
          <li>
            Custom Goal : Set your own Market Share Goal for a specific time
            period (e.g., next quarter or year). This gives you full control
            over your planning.
          </li>
        </ol>
        <li>Save and Act</li>
        <li>
          Once you’ve set your goal, we’ll save it and provide actionable steps
          to help you achieve it. These recommendations ensure you stay on track
          and make informed decisions.
        </li>
      </ol>
      <p>Why Set a Market Share Goal?</p>
      <ul>
        <li>Gain clarity on measurable growth targets.</li>
        <li>Stay competitive by aligning with market trends.</li>
        <li>Make smarter, data-backed decisions for long-term success.</li>
      </ul>
      <p>
        Whether you choose a recommended goal or create your own, our platform
        supports you every step of the way.
      </p>
    </div>
  );
};
